import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, buildError, API } from '../../api/apis';
import { ApiResponse, LinkPayload, LinkResponse } from '../../interfaces/interfaces';

export const linksService = createApi({
  reducerPath: 'linksApi',
  tagTypes: ['Links'],
  baseQuery: fetchBaseQuery({
    prepareHeaders: prepareHeaders,
  }),
  endpoints: (builder) => ({
    getLinks: builder.query({
      query: () => API.FETCH_LINKS(),
      providesTags: () => [{ type: 'Links', id: 'LIST' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response?.Links as Record<string, LinkResponse>;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
    createLink: builder.mutation({
      query: (payload: LinkPayload) => ({
        url: API.CREATE_LINK(),
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: [{ type: 'Links', id: 'LIST' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response as LinkResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
    updateLink: builder.mutation({
      query: ({ linkId, ...payload }: LinkPayload & { linkId: string }) => ({
        url: API.UPDATE_LINK(linkId),
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: [{ type: 'Links', id: 'LIST' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response as LinkResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
    deleteLink: builder.mutation({
      query: (linkId: string) => ({
        url: API.DELETE_LINK(linkId),
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Links', id: 'LIST' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
  }),
});

export const {
  useGetLinksQuery,
  useLazyGetLinksQuery,
  useCreateLinkMutation,
  useUpdateLinkMutation,
  useDeleteLinkMutation,
} = linksService;
